<hr />
<div class="container-fluid my-2">
  <div class="col-sm-4">
    <h6>Acuerdos Comerciales</h6>
  </div>
  <div class="row">
    <div class="filters-container">
      <form [formGroup]="filterForm">
        <div class="filter-container row">
          <!-- Fecha de Inicio -->
          <div class="form-group">
            <label for="dateRange">Fecha</label>
            <input
              type="month"
              id="dateRange"
              formControlName="dateRange"
              class="form-control"
            />
          </div>
          <!-- Patente -->
          <div style="min-width: 105px" class="form-group col-sm-2 col-lg-1">
            <label for="patente">Patente</label>
            <input
              type="text"
              id="patente"
              formControlName="plate"
              placeholder="AABB11"
              class="form-control"
              appInputUppercase
            />
          </div>
          <!-- SAP ID -->
          <div class="form-group col-sm-2 col-lg-1">
            <label for="patente">SAP ID</label>
            <input
              type="text"
              id="sapID"
              formControlName="sapID"
              placeholder="85026"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="Transportista">Transportista</label>
            <select
              id="Transportista"
              formControlName="carrier"
              class="form-control"
            >
              <option selected disabled hidden value="">Seleccione</option>
              <option
                *ngFor="let Transportista of CARRIERS"
                [value]="Transportista.valueId"
              >
                {{ Transportista.valueToDisplay }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="center">Centro</label>
            <select id="center" formControlName="center" class="form-control">
              <option selected disabled hidden value="">Seleccione</option>
              <option *ngFor="let center of CENTERS" [value]="center.valueId">
                {{ center.valueToDisplay }}
              </option>
            </select>
          </div>

          <div class="form-group col-sm-2 col-lg-2">
            <label for="status">Estado</label>
            <select id="Estado" formControlName="status" class="form-control">
              <option selected disabled hidden value="">Seleccione</option>
              <option *ngFor="let option of STATUSES" [value]="option.valueId">
                {{ option.valueToDisplay }}
              </option>
            </select>
          </div>
          <div class="col-sm-2 col-lg-2 col-xl-1 text-center mt-auto">
            <button
              type="button"
              class="btn btn-outline-primary htr-button"
              (click)="onFilter()"
            >
              Filtrar
            </button>
          </div>
          <div class="col-sm-2 col-lg-2 col-xl-1 text-center mt-auto">
            <button
              type="button"
              class="btn btn-outline-primary htr-button"
              (click)="cleanFilters()"
              style="height: 38px"
            >
              <span class="material-symbols-outlined"> refresh </span>
            </button>
          </div>
        </div>
      </form>
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-outline-primary dropdownButton"
          id="dropdownActionsAgreements"
          ngbDropdownToggle
        >
          Acciones
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActionsAgreements">
          <a
            id="ActionsAgreements"
            ngbDropdownItem
            [disabled]="!isButtonActive('aprove')"
            (click)="showUpdateListModal('aprove')"
          >
            Aprobar</a
          >
          <a
            id="ActionsAgreements"
            ngbDropdownItem
            [disabled]="!isButtonActive('reject')"
            (click)="showUpdateListModal('reject')"
          >
            Rechazar</a
          >
          <a
            id="ActionsAgreements"
            [disabled]="!isButtonActive('createExisting')"
            (click)="showCreateModal(true)"
            ngbDropdownItem
          >
            Crear desde existente</a
          >
          <a
            id="ActionsAgreements"
            ngbDropdownItem
            [disabled]="!isButtonActive('cancel')"
            (click)="showUpdateListModal('cancel')"
          >
            Dar de baja</a
          >
          <hr class="dropdown-divider" />
          <a
            id="ActionsAgreements"
            ngbDropdownItem
            [disabled]="!isButtonActive('create')"
            (click)="showCreateModal()"
          >
            Crear</a
          >
          <a
            id="ActionsAgreements"
            ngbDropdownItem
            [disabled]="!isActiveUpload()"
            (click)="showUploadModal()"
          >
            Crear masivamente</a
          >
          <hr class="dropdown-divider" />
          <a
            id="ActionsAgreements"
            [disabled]="!isButtonActive('excel')"
            (click)="downloadCommercialAgreements()"
            ngbDropdownItem
          >
            Descargar</a
          >
        </div>
      </div>
    </div>

    <div class="table-responsive-sm mt-4" *ngIf="!isGettingAgreements">
      <form [formGroup]="commercialFormGroup">
        <table
          class="table table-striped table-ac"
          [ngClass]="{ empty: ACToView.length === 0 }"
        >
          <caption style="display: none">
            Lista de Acuerdos Comerciales
          </caption>
          <thead>
            <tr>
              <th scope="col">
                <input
                  (change)="selectAll($event)"
                  (click)="$event.stopPropagation()"
                  type="checkbox"
                  name="selectAll"
                  id="selectAll"
                />
              </th>
              <th scope="col" (click)="onSort('sapId')" class="text-center">
                Vehículo
                <span class="filter-icon" *ngIf="sortColumn === 'sapId'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('center')" class="text-center">
                Centro
                <span class="filter-icon" *ngIf="sortColumn === 'center'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th
                scope="col"
                (click)="onSort('modelTypeName')"
                class="text-center"
              >
                Tipo Vehículo
                <span
                  class="filter-icon"
                  *ngIf="sortColumn === 'modelTypeName'"
                >
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('carrier')" class="text-center">
                Transportista
                <span class="filter-icon" *ngIf="sortColumn === 'carrier'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('capacity')" class="text-center">
                Capacidad
                <span class="filter-icon" *ngIf="sortColumn === 'capacity'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('type')" class="text-center">
                Acuerdo
                <span class="filter-icon" *ngIf="sortColumn === 'type'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th
                scope="col"
                (click)="onSort('guaranteed')"
                class="text-center"
              >
                Monto Garantizado
                <span class="filter-icon" *ngIf="sortColumn === 'guaranteed'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th
                scope="col"
                (click)="onSort('additionalPercentage')"
                class="text-center"
              >
                % Variable
                <span
                  class="filter-icon"
                  *ngIf="sortColumn === 'additionalPercentage'"
                >
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('startTime')" class="text-center">
                Fecha Inicio
                <span class="filter-icon" *ngIf="sortColumn === 'startTime'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('endTime')" class="text-center">
                Fecha Fin
                <span class="filter-icon" *ngIf="sortColumn === 'endTime'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('createdBy')" class="text-center">
                Solicitante
                <span class="filter-icon" *ngIf="sortColumn === 'createdBy'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th scope="col" (click)="onSort('status')" class="text-center">
                Estado
                <span class="filter-icon" *ngIf="sortColumn === 'status'">
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                </span>
              </th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody formArrayName="commercialAgreementsForm">
            <tr
              *ngFor="let commercialAgreement of ACToView; let i = index"
              [formGroupName]="i - 1 + firstItemIndex"
            >
              <td class="text-center">
                <input
                  formControlName="selected"
                  type="checkbox"
                  [id]="i - 1 + firstItemIndex"
                />
              </td>
              <td class="text-center">
                {{ commercialAgreement.value.AC.sapId | sapId }} -
                {{ commercialAgreement.value.AC.entityId }}
              </td>
              <td class="text-center">
                {{ commercialAgreement.value.AC.center | master : "CENTERS" }}
              </td>
              <td class="text-center">
                {{ commercialAgreement.value.AC.modelTypeName }}
              </td>
              <td class="text-center">
                {{ CARRIERSINDEX[commercialAgreement.value.AC.carrier] }}
              </td>
              <td class="text-center">
                {{
                  commercialAgreement.value.AC.capacity
                    | master
                      : commercialAgreement.value.AC.modelTypeName.toUpperCase() +
                          "S#CAPACITIES"
                }}
                M3
              </td>
              <td class="text-center">
                {{
                  commercialAgreement.value.AC.type
                    | master : "COMMERCIALAGREEMENT#TYPES"
                }}
              </td>
              <td class="text-center">
                {{
                  getFormattedAmount(
                    commercialAgreement.value.AC.guaranteed,
                    commercialAgreement.value.AC?.guaranteedUoM
                  )
                }}
              </td>
              <td class="text-center">
                {{
                  (commercialAgreement.value.AC.additionalPercentage ?? 0) > 0
                    ? (commercialAgreement.value.AC.additionalPercentage * 100
                        | number : "1.0-0") + "%"
                    : ""
                }}
              </td>
              <td class="text-center">
                {{
                  commercialAgreement.value.AC.startTime
                    | date : "dd/MM/yyyy" : "UTC"
                }}
              </td>
              <td class="text-center">
                {{
                  commercialAgreement.value.AC.endTime
                    | date : "dd/MM/yyyy" : "UTC"
                }}
              </td>
              <td class="text-center">
                {{ commercialAgreement.value.AC.createdBy }}
              </td>
              <td class="text-center">
                {{
                  commercialAgreement.value.AC.status
                    | master : "COMMERCIALAGREEMENT#STATUSES"
                }}
              </td>
              <td>
                <label class="custom-file-upload mx-1" style="cursor: pointer">
                  <a
                    id="list_alt-evaluation"
                    title="Visualizar"
                    (click)="
                      open(offcanvasContent, commercialAgreement.value.AC)
                    "
                  >
                    <span class="material-symbols-outlined text-secondary"
                      >list_alt</span
                    >
                  </a>
                </label>
                <label
                  *ngIf="commercialAgreement.value.AC.comment"
                  class="custom-file-upload mx-1"
                  style="cursor: pointer"
                  ngbTooltip="{{ commercialAgreement.value.AC.comment }}"
                >
                  <span class="material-symbols-outlined text-secondary"
                    >sms</span
                  >
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
      <pre>{{ firstItemIndex }} a {{ lastItemIndex }} de {{ total }}</pre>
      <div class="d-flex justify-content-center p-2">
        <ngb-pagination
          [collectionSize]="total"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="paginate()"
        >
        </ngb-pagination>
      </div>
    </div>

    <div class="row">
      <div class="text-center my-5" *ngIf="isGettingAgreements">
        <app-spinner message="Cargando Acuerdos Comerciales"></app-spinner>
      </div>
    </div>
  </div>
</div>

<!-- Modals -->
<ng-template #uploadModal let-c="close" let-d="dismiss">
  <app-upload
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-upload>
</ng-template>

<ng-template #updateListModal let-c="close" let-d="dismiss">
  <app-update
    [action]="action"
    [List]="selectedAgreements"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-update>
</ng-template>

<ng-template #createModal let-c="close" let-d="dismiss">
  <app-create
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
    [aC]="fromExistingAc"
  ></app-create>
</ng-template>

<ng-template #offcanvasContent let-offcanvas>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header">
      <h4 class="offcanvas-title" id="offcanvas-basic-title">
        Acuerdo comercial
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="offcanvas.dismiss('Cross click')"
      ></button>
    </div>
    <div class="row" *ngIf="offCanvasAc">
      <p class="sub-canvas">
        {{ offCanvasAc.sapId ? (offCanvasAc.sapId | sapId) : ("" | sapId) }} -
        {{ offCanvasAc.entityId }} con inicio el
        {{ offCanvasAc.startTime | date : "dd/MM/yyyy" : "UTC" }}
      </p>
    </div>

    <div>
      <app-commercial-agreements-details
        [agreement]="openAC"
        [isColapsed]="true"
      ></app-commercial-agreements-details>
    </div>

    <div class="offcanvas-body flex-grow-1 overflow-auto">
      <h4>Historia</h4>
      <hr />

      <div *ngFor="let history of historyFormatArray">
        <p class="broke-word">
          {{ history.updatedAt | date : "dd/MM/yyyy HH:mm" : "UTC" }}
          <strong>
            {{
              history.status | master : "COMMERCIALAGREEMENT#STATUSES"
            }}</strong
          >
          por {{ history.updatedBy }}
          <ng-container *ngIf="history.comment">
            <br />
            Comentario: {{ history.comment }}
          </ng-container>
        </p>
      </div>
    </div>
    <div class="p-3 border-top">
      <div class="text-end">
        <button
          type="button"
          class="btn btn-primary"
          (click)="offcanvas.close('Close click')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>
